import { Route, Routes, Outlet, Navigate } from 'react-router-dom'
import { PageLink, PageTitle } from '../../../_metronic/layout/core'
import { PurchasedProductsListWrapper } from './purchasedproducts-list/PurchasedProductsList'
import AccountPage from '../../modules/accounts/AccountPage'
import { AccountHeader } from '../../modules/accounts/AccountHeader'
import { Settings } from '../../modules/accounts/components/settings/Settings'
import { Overview } from '../../modules/accounts/components/Overview'

const purchasedproductsBreadcrumbs: Array<PageLink> = [
  {
    title: 'PurchasedProduct Management',
    path: '/admin/pages/purchasedproducts',
    isSeparator: false,
    isActive: false,
  },
  {
    title: '',
    path: '',
    isSeparator: true,
    isActive: false,
  },
]
const accountBreadCrumbs: Array<PageLink> = [
  {
    title: 'Account',
    path: '/admin/pages/purchasedproducts/overview',
    isSeparator: false,
    isActive: false,
  },
  {
    title: '',
    path: '',
    isSeparator: true,
    isActive: false,
  },
]
const PurchasedProductsPage = () => {
  return (
    <Routes>
      <Route element={<Outlet />}>
        <Route
          // path='purchasedproducts'
          index
          element={
            <>
              <PageTitle breadcrumbs={purchasedproductsBreadcrumbs}>PurchasedProducts list</PageTitle>
              <PurchasedProductsListWrapper />
            </>
          }
        />

        <Route
          element={
            <>
              <AccountHeader />
              <Outlet />
            </>
          }
        >
          <Route
            path='overview'
            element={
              <>
                <PageTitle breadcrumbs={accountBreadCrumbs}>Overview</PageTitle>
                <Overview />
              </>
            }
          />
          <Route
            path='settings'
            element={
              <>
                <PageTitle breadcrumbs={accountBreadCrumbs}>Settings</PageTitle>
                <Settings />
              </>
            }
          />
          <Route index element={<Navigate to='/admin/pages/purchasedproducts/overview' />} />
        </Route>

      </Route>
      <Route index element={<Navigate to='/admin/pages/purchasedproducts' />} />
    </Routes>
  )
}

export default PurchasedProductsPage
